import React, { Component } from "react"
import Datetime from "react-datetime"
import Text from "components/text"
import moment from "moment"

import "react-datetime/css/react-datetime.css"
import "./index.scss"

class FormDatePicker extends Component {
  renderInput(props) {
    const { dateFormat = "MMMM D, YYYY" } = this.props
    const { value } = props

    const dateValue = moment(value).isValid()
      ? moment(value).format(dateFormat)
      : null

    return <input {...props} value={dateValue} />
  }

  render() {
    const {
      name,
      label,
      value,
      dateFormat,
      error,
      handleChangeDate,
      horizontal,
      required,
      hint,
      ...props
    } = this.props

    const dateValue = moment(value).isValid() ? moment(value) : null

    const { iid } = props
    const inputProps = {
      readOnly: true,
    }

    return (
      <div
        className={`form-input datepicker ${
          horizontal ? "-horizontal" : "-vertical"
        }`}
      >
        <Text type="label" text={label + (required ? " *" : "")} />
        <Datetime
          name={name}
          value={dateValue}
          timeFormat={false}
          inputProps={inputProps}
          onChange={handleChangeDate}
          instanceId={iid}
          closeOnSelect={true}
          renderInput={(props) => this.renderInput(props)}
        />
        {hint ? <p className="form-hint">{hint}</p> : null}
        {error ? <p className="error-message">{`* ${error}`}</p> : null}
      </div>
    )
  }
}

export default FormDatePicker
